import React from 'react';

const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        className={`animate-spin rounded-full border-2 border-gray-300 border-t-[#202654] ${sizeClasses[size]}`}
      ></div>
    </div>
  );
};

// Version avec message
export const LoadingSpinnerWithMessage = ({ message = 'Chargement...', size = 'md' }) => {
  return (
    <div className="flex flex-col items-center justify-center p-8 space-y-4">
      <LoadingSpinner size={size} />
      <p className="text-gray-600 text-sm">{message}</p>
    </div>
  );
};

// Version pleine page
export const FullPageLoader = ({ message = 'Chargement...' }) => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <LoadingSpinnerWithMessage message={message} size="lg" />
    </div>
  );
};

export default LoadingSpinner; 